import { apiV1Client } from "lib/apiClient";
import { ApiResponse } from "types/api";
import { WORKER_OPERATIONS } from "types/operations";
import { CleaningRobotListResponse } from "types/response/robot";
import { ConsumablePartType } from "utils/robot/consumablePart";

const workerPath = "/worker";

/**
 * 担当ビルに紐づくロボット一覧を取得
 */
export const callListRobot = async () => {
  const res = await apiV1Client.post<ApiResponse<CleaningRobotListResponse>>(
    workerPath,
    {
      operation: WORKER_OPERATIONS.robot.listInCurrentBuilding,
    }
  );
  return res.data.data;
};

type UpdateSettingParams = {
  robotId: string;
  parts: {
    type: ConsumablePartType;
    usage: number;
  }[];
};

/**
 * ロボットの設定更新リクエストを送信
 */
export const callUpdateRobotConsumablePart = async (
  input: UpdateSettingParams
) => {
  await apiV1Client.post<ApiResponse<null>>(workerPath, {
    operation: WORKER_OPERATIONS.robot.updatePartsInfo,
    data: {
      robotId: input.robotId,
      consumableParts: input.parts,
    },
  });
};

type UpdateParams = {
  robotId: string;
  robotName: string;
  description?: string;
};

/**
 * ロボットの設定更新リクエストを送信
 */
export const callUpdateRobot = async (input: UpdateParams) => {
  await apiV1Client.post<ApiResponse<null>>(workerPath, {
    operation: WORKER_OPERATIONS.robot.update,
    data: {
      robotId: input.robotId,
      robotName: input.robotName,
      description: input.description,
    },
  });
};
